document.addEventListener("DOMContentLoaded", function () {
    console.log("section-article-you-may-also-like.js loaded")

    const $articleYouMayAlsoLike = $("section.article-you-may-also-like")
    const $articleYouMayAlsoLikeWrapper = $articleYouMayAlsoLike.find(".wrapper")
    const $articles = $articleYouMayAlsoLikeWrapper.find(".articles")

    // console.log("$articleYouMayAlsoLike", $articleYouMayAlsoLike)
    // console.log("$articleYouMayAlsoLikeWrapper", $articleYouMayAlsoLikeWrapper)
    // console.log("$articles", $articles)

    $articles.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: $articleYouMayAlsoLikeWrapper.find('.slick-prev'),
        nextArrow: $articleYouMayAlsoLikeWrapper.find('.slick-next'),
        mobileFirst: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: "unslick"
            }
        ]
    })
})
